"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAuthorized = exports.default = exports.checkAuth = exports.check = exports.isEntitled = exports.UserContext = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * A component to check authorization
 * @example
 * <IsAuthorized
 *  perform={"CRAWDCT"}
 *  yes={() => "Authorized"}
 *  no={() => "Not Authorized"}
 * />
 *
 */

/**
 * Use as function return true/false
 * @example
 * const isAuthorized = isEntitled({ user, perform : "CRAWDCT" })
 *
 */
var UserContext = /*#__PURE__*/_react.default.createContext({});

exports.UserContext = UserContext;

var isEntitled = function isEntitled(_ref) {
  var user = _ref.user,
      app = _ref.app,
      _ref$perform = _ref.perform,
      perform = _ref$perform === void 0 ? [] : _ref$perform,
      data = _ref.data;
  var roles = (user.roles || []).filter(function (role) {
    return !app || role.appName === app;
  });
  var appFns = roles.map(function (role) {
    return role.appFns;
  });
  var plainArray = [].concat.apply([], appFns);
  var actions = Array.isArray(perform) ? perform : [perform];
  return !!actions.filter(function (action) {
    return plainArray.includes(action);
  }).length;
};

exports.isEntitled = isEntitled;
var check = isEntitled;
exports.check = check;

var checkAuth = function checkAuth(user, app, appAccessFn) {
  var roles = user.roles.filter(function (role) {
    return role.appName === app;
  });
  return roles[0].appFns.includes(appAccessFn);
};

exports.checkAuth = checkAuth;

function IsAuthorized(props) {
  var user = (0, _react.useContext)(UserContext);

  var yes = props.yes,
      no = props.no,
      rest = _objectWithoutProperties(props, ["yes", "no"]);

  return isEntitled(_objectSpread({
    user: user
  }, rest)) ? yes() : no();
}

IsAuthorized.defaultProps = {
  no: function no() {
    return false;
  },
  yes: function yes() {
    return true;
  }
};
var _default = IsAuthorized;
exports.default = _default;

var isAuthorized = function isAuthorized() {
  var YesComp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    return "Authorized";
  };
  var NoComp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return "Not Authorized";
  };
  return function (props) {
    var perform = props.perform,
        rest = _objectWithoutProperties(props, ["perform"]);

    return /*#__PURE__*/_react.default.createElement(IsAuthorized, {
      perform: perform,
      yes: function yes() {
        return /*#__PURE__*/_react.default.createElement(YesComp, rest);
      },
      no: function no() {
        return /*#__PURE__*/_react.default.createElement(NoComp, rest);
      }
    });
  };
};

exports.isAuthorized = isAuthorized;